<template>
<div class="chapter">
<div class="inner_page">
<div class="toc" id="toc">
<h1 class="toc">Contents</h1>
<p class="nonindent01"><a class="hlink" href="#/OEBPS/9780740799426_epub_int_r1.htm">Introduction</a></p>
<p class="nonindent01"><a class="hlink" href="#/OEBPS/9780740799426_epub_c09_r1.htm">The Engagement</a></p>
<p class="nonindent01"><a class="hlink" href="#/OEBPS/9780740799426_epub_c123_r1.htm">The Wedding</a></p>
<p class="nonindent01"><a class="hlink" href="#/OEBPS/9780740799426_epub_c139_r1.htm">Scenes from a 27-Year Courtship</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740799426_epub_toc_r1.vue?c1f49c60